module.exports = __webpack_public_path__ + "img/COM-B-2-II.7a953171.png";